(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffs-product-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function formatDescriptionTables(root) {
      root.querySelectorAll('.ffs-description__content table').forEach((table) => {
        if (table.closest('.ffs-description__table-scroll')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'ffs-description__table-scroll';
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', 'Product information table');

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    }

    formatDescriptionTables(document);

    document.addEventListener('shopify:section:load', (event) => {
      formatDescriptionTables(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-complete-repair-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initNPRepairV2(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const settings = JSON.parse(
        root.querySelector('[data-np-settings]').textContent
      );

      const base = settings.root.endsWith('/')
        ? settings.root
        : settings.root + '/';

      const drawer = root.querySelector('[data-np-drawer]');
      const message = root.querySelector('[data-np-message]');

      let busy = false;
      let previousFocus = null;
      let previousOverflow = '';

      function money(value, currency) {
        return new Intl.NumberFormat(
          document.documentElement.lang || 'en-AU',
          {
            style: 'currency',
            currency: currency || settings.currency
          }
        ).format(value / 100);
      }

      function showMessage(text) {
        message.textContent = text;
        message.hidden = !text;
      }

      async function request(path, options = {}) {
        const response = await fetch(base + path, {
          ...options,
          headers: {
            Accept: 'application/json',
            ...(options.headers || {})
          }
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(
            result.description ||
            result.message ||
            'Unable to update your cart.'
          );
        }

        return result;
      }

      function renderCart(cart) {
        const container = root.querySelector('[data-np-cart-items]');
        container.replaceChildren();

        cart.items.forEach(item => {
          const row = document.createElement('article');
          row.className = 'np-r2__cart-item';

          const image = document.createElement('img');
          image.width = 70;
          image.height = 70;
          image.alt = item.product_title;

          if (item.image) image.src = item.image;
          else image.hidden = true;

          const content = document.createElement('div');
          const title = document.createElement('h3');
          const detail = document.createElement('p');

          title.textContent = item.product_title;
          detail.textContent =
            item.quantity + ' × ' + money(item.final_price, cart.currency);

          content.append(title, detail);
          row.append(image, content);
          container.append(row);
        });

        root.querySelector('[data-np-cart-total]').textContent =
          money(cart.total_price, cart.currency);
      }

      function openDrawer() {
        if (drawer.open) return;

        previousFocus = document.activeElement;
        previousOverflow = document.body.style.overflow;

        drawer.showModal();
        document.body.style.overflow = 'hidden';
      }

      root.querySelector('[data-np-close]').addEventListener(
        'click', () => drawer.close()
      );

      drawer.addEventListener('close', () => {
        document.body.style.overflow = previousOverflow;
        if (previousFocus?.isConnected) previousFocus.focus();
      });

      drawer.addEventListener('click', event => {
        const bounds = drawer.getBoundingClientRect();

        if (
          event.target === drawer &&
          (event.clientX < bounds.left || event.clientX > bounds.right)
        ) {
          drawer.close();
        }
      });

      root.querySelectorAll('[data-np-add-form]').forEach(form => {
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (busy) return;

          const button = form.querySelector('button');
          const originalText = button.textContent;

          busy = true;
          button.disabled = true;
          button.textContent = 'Adding…';
          button.setAttribute('aria-busy', 'true');
          showMessage('');

          try {
            await request('cart/add.js', {
              method: 'POST',
              body: new FormData(form)
            });

            // The add succeeded. Never retry it on a cart-refresh failure.
            try {
              const cart = await request('cart.js');
              renderCart(cart);
              openDrawer();

              document.dispatchEvent(
                new CustomEvent('ffs:cart-updated', {
                  detail: { cart, source: 'complete_repair' }
                })
              );
            } catch {
              showMessage(
                'Item added. Open your store cart to review it.'
              );
            }
          } catch (error) {
            showMessage(error.message);
          } finally {
            busy = false;
            button.disabled = false;
            button.textContent = originalText;
            button.removeAttribute('aria-busy');
          }
        });
      });
    }

    function initialiseAll(container) {
      container.querySelectorAll('[data-np-repair-v2]').forEach(initNPRepairV2);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll(document));
    } else {
      initialiseAll(document);
    }

    document.addEventListener('shopify:section:load', event => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
